<template>
    <div>
        <label class="field_label">{{ current_champ.label }}<span class="text-red"
                v-if="current_champ.mandatory == 1">*</span></label>
        <v-phone-input v-model="current_champ.value" label="Numéro de téléphone" enable-searching-country
            class="phone-input-field"
            :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"
            default-country="FR" invalid-message="Ce numéro de téléphone n'est pas valide" />


    </div>
</template>

<script>

export default {
    props: ["champ", "inscription", "mode", "is_disable"],
    data() {
        return {
            current_champ: {},
        };
    },
    watch: {
        champ: {
            deep: true,
            handler() {
                this.current_champ = this.champ;
                this.$forceUpdate();
            },
        },
    },
    computed: {

    },
    methods: {


    },
    created() {
        this.current_champ = this.champ;
    },
};
</script>

<style lang="scss">
.phone-input-field {
    display: flex;

    .v-phone-input__country__input {
        display: inline-block !important;
        width: 100px !important; // Largeur par défaut
        max-width: 100px !important;
        transition: width 0.3s ease; // Animation fluide pour le changement de largeur

        &.v-phone-input--focused {
            width: 200px !important;
            max-width: 200px !important;
        }
    }

}
</style>